(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lov-size-advisor"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('lov-size-advisor')) return;

  const memory = {};

  const read = (pid) => {
    if (memory[pid]) return memory[pid];
    try {
      const raw = sessionStorage.getItem('lov-size-advisor-' + pid);
      if (raw) memory[pid] = JSON.parse(raw);
    } catch (e) {}
    return memory[pid] || null;
  };
  const write = (pid, data) => {
    memory[pid] = data;
    try { sessionStorage.setItem('lov-size-advisor-' + pid, JSON.stringify(data)); } catch (e) {}
  };

  // Drop 4 (XS·S / M·L / XL·XXL) – h: Größe 0–3 · w: Gewicht 0–3 · f: 0 Relaxed / 1 Oversized
  // LOV 19.10.2026: Ab 1,85 m bis 89 kg bei Relaxed M·L statt XL·XXL (Rückmeldung: 1,87 m / ca. 87 kg trägt M·L).
  const recommendDrop4 = (h, w, f, crewneck) => {
    let size = 1;
    let alt = '';
    if (h === 0) {
      size = w >= 2 ? 1 : 0;
    } else if (h === 1 || h === 2) {
      if (w === 3) {
        if (f === 1) size = 2;
        else { size = 1; alt = 'Liegst du am oberen Rand? XL·XXL sitzt entspannter.'; }
      } else if (h === 1 && w === 0 && f === 0) {
        size = 0;
      } else {
        size = 1;
      }
    } else if (f === 0 && w <= 2) {
      size = 1;
      alt = 'Über 1,90 m oder lange Arme? Dann XL·XXL.';
    } else {
      size = 2;
      if (crewneck && w <= 1) alt = 'Eher kurze Arme? Dann passt dir auch M·L.';
    }
    return { size, alt };
  };

  // GUEZEL SUMMER (Doppelgrößen, fällt groß aus): Drop-4-Logik für oversized,
  // relaxed eine Größe kleiner, solange das Gewicht nicht über der Körpergröße liegt.
  const recommendSummer = (h, w, f, sizes) => {
    const base = recommendDrop4(h, w, 1, false).size;
    if (f === 0 && w <= h && base > 0) {
      return { size: base - 1, alt: 'Lieber mehr Weite? Dann ' + sizes[base] + '.' };
    }
    return { size: base, alt: '' };
  };

  // Einzelgrößen XS–XXL (ältere Pieces) – h und w: 0–5 nach Tabelle, f: 0 Relaxed / 1 Oversized
  const recommendSingle = (h, w, f, profile, sizes) => {
    let size;
    let alt = '';
    if (w === h) {
      size = f === 1 ? h : Math.max(0, h - 1);
    } else if (w > h) {
      size = Math.max(h, w - 1);
    } else {
      const lo = Math.floor((h + w) / 2);
      const hi = Math.ceil((h + w) / 2);
      size = f === 1 ? hi : lo;
      if (f === 0 && hi !== lo) alt = 'Lieber mehr Länge? Dann ' + sizes[hi] + '.';
      if (profile !== 'single-tee') {
        size = Math.max(size, h - 1);
        if (size < sizes.length - 1) alt = 'Lange Arme? Dann ' + sizes[size + 1] + '.';
      }
    }
    size = Math.min(sizes.length - 1, Math.max(0, size));
    if (profile === 'single-long' && !alt && size < sizes.length - 1) alt = 'Lange Arme? Dann ' + sizes[size + 1] + '.';
    return { size, alt };
  };

  class LovSizeAdvisor extends HTMLElement {
    connectedCallback() {
      this.pid = this.dataset.productId;
      this.profile = this.dataset.profile || 'drop4';
      try { this.sizes = JSON.parse(this.dataset.sizes); } catch (e) { this.sizes = ['XS·S', 'M·L', 'XL·XXL']; }
      this.crewneck = this.dataset.crewneck === 'true';
      this.sheet = this.querySelector('[data-sheet]');
      const saved = read(this.pid);
      this.answers = saved && saved.answers ? { ...saved.answers } : {};

      if (!this._bound) {
        this._bound = true;
        this.addEventListener('click', (event) => {
          const t = event.target;
          if (t.closest('[data-open]')) { this.open(); return; }
          if (t.closest('[data-close]')) { this.close(); return; }
          const chip = t.closest('.lov-size-advisor__chips button');
          if (chip) { this.answer(chip); return; }
          if (t.closest('[data-apply]')) this.apply();
        });
        this.onKey = (event) => {
          if (event.key === 'Escape' && this.sheet.classList.contains('is-open')) this.close();
        };
      }
      this.renderSheet();
      LovSizeAdvisor.watch();
      LovSizeAdvisor.syncAll();
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKey);
      if (this.sheet && this.sheet.classList.contains('is-open')) {
        document.documentElement.style.overflow = this.prevOverflow || '';
      }
    }

    inputs() {
      const scope = this.closest('.shopify-section') || document;
      return [...scope.querySelectorAll('variant-picker input[type="radio"]')].filter((i) => this.sizes.includes(i.value));
    }

    open() {
      this.renderSheet();
      this.prevOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.sheet.classList.add('is-open');
      this.sheet.setAttribute('aria-hidden', 'false');
      document.addEventListener('keydown', this.onKey);
      this.sheet.querySelector('.lov-size-advisor__panel').focus({ preventScroll: true });
    }

    close() {
      this.sheet.classList.remove('is-open');
      this.sheet.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', this.onKey);
      document.documentElement.style.overflow = this.prevOverflow || '';
    }

    answer(chip) {
      const key = chip.closest('[data-q]').dataset.q;
      this.answers[key] = Number(chip.dataset.v);
      this.renderSheet();
    }

    result() {
      const { h, w, f } = this.answers;
      if (h === undefined || w === undefined || f === undefined) return null;
      if (this.profile === 'drop4') return recommendDrop4(h, w, f, this.crewneck);
      if (this.profile === 'dual-summer') return recommendSummer(h, w, f, this.sizes);
      return recommendSingle(h, w, f, this.profile, this.sizes);
    }

    renderSheet() {
      this.querySelectorAll('[data-q]').forEach((q) => {
        const val = this.answers[q.dataset.q];
        q.querySelectorAll('button').forEach((b) => b.setAttribute('aria-pressed', String(Number(b.dataset.v) === val)));
      });
      const res = this.result();
      const box = this.querySelector('[data-result]');
      this.querySelector('[data-wait]').hidden = !!res;
      box.hidden = !res;
      if (!res) return;
      const size = this.sizes[res.size];
      const models = this.profile === 'drop4' ? [this.dataset.modelSmall || '', this.dataset.modelMedium || '', ''] : [];
      this.querySelector('[data-result-size]').textContent = size;
      const altEl = this.querySelector('[data-result-alt]');
      altEl.textContent = res.alt;
      altEl.hidden = !res.alt;
      const modelEl = this.querySelector('[data-result-model]');
      modelEl.textContent = models[res.size] || '';
      modelEl.hidden = !models[res.size];
      this.querySelector('[data-apply]').textContent = size + ' wählen';
    }

    apply() {
      const res = this.result();
      if (!res) return;
      const size = this.sizes[res.size];
      write(this.pid, { answers: { ...this.answers }, size });
      this.close();
      const input = this.inputs().find((i) => i.value === size);
      if (input && !input.checked) input.click();
      LovSizeAdvisor.syncAll();
    }

    needsSize() {
      const inputs = this.inputs();
      return inputs.length > 0 && !inputs.some((i) => i.checked);
    }

    sync() {
      const needs = this.needsSize();
      const section = this.closest('.shopify-section');
      if (section) section.classList.toggle('lov-needs-size', needs);
      // Pflichtfeld im Warenkorb-Formular, solange keine Größe gewählt ist (verhindert Kauf und Häkchen-Animation)
      const form = section && section.querySelector('form[action*="/cart/add"]');
      if (form) {
        const req = form.querySelector('.lov-size-required');
        if (needs && !req) {
          const el = document.createElement('input');
          el.type = 'text';
          el.className = 'lov-size-required';
          el.required = true;
          el.tabIndex = -1;
          el.setAttribute('aria-hidden', 'true');
          el.style.display = 'none';
          form.appendChild(el);
        } else if (!needs && req) {
          req.remove();
        }
      }
      const need = this.querySelector('[data-need]');
      if (!needs && !need.hidden) need.hidden = true;
      const saved = read(this.pid);
      const size = saved && saved.size;
      const prompt = this.querySelector('[data-prompt]');
      const status = this.querySelector('[data-status]');
      if (prompt.hidden !== !!size) prompt.hidden = !!size;
      if (status.hidden !== !size) status.hidden = !size;
      this.classList.toggle('has-rec', !!size);
      if (size) {
        const el = this.querySelector('[data-status-size]');
        if (el.textContent !== size) el.textContent = size;
      }
      // „FÜR DICH" unter dem empfohlenen Größen-Button
      const mark = this.querySelector('[data-mark]');
      const input = size ? this.inputs().find((i) => i.value === size) : null;
      const label = input ? input.closest('label') : null;
      if (label && label.offsetParent) {
        const lr = label.getBoundingClientRect();
        const ar = this.getBoundingClientRect();
        const x = Math.round(lr.left + lr.width / 2 - ar.left) + 'px';
        if (mark.style.left !== x) mark.style.left = x;
        if (mark.hidden) mark.hidden = false;
      } else if (!mark.hidden) {
        mark.hidden = true;
      }
    }

    // Warenkorb ohne gewählte Größe abfangen
    static guard(event) {
      const t = event.target;
      if (!(t instanceof Element)) return;
      const isAdd = event.type === 'submit'
        ? t.matches('form[action*="/cart/add"]')
        : !!t.closest('button[name="add"], .add-to-cart-button');
      if (!isAdd) return;
      const section = t.closest('.shopify-section');
      const advisor = section && section.querySelector('lov-size-advisor');
      if (!advisor || !advisor.needsSize()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      advisor.showNeed();
    }

    showNeed() {
      const need = this.querySelector('[data-need]');
      need.hidden = false;
      const picker = (this.closest('.shopify-section') || document).querySelector('variant-picker');
      if (picker) {
        const r = picker.getBoundingClientRect();
        if (r.top < 0 || r.bottom > window.innerHeight) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    static syncAll() {
      document.querySelectorAll('lov-size-advisor').forEach((el) => el.sync && el.sync());
    }

    // Der Variant-Picker wird nach jeder Auswahl neu gerendert – Markierung danach wieder setzen.
    static watch() {
      if (LovSizeAdvisor.observer) return;
      let queued = false;
      LovSizeAdvisor.observer = new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => { queued = false; LovSizeAdvisor.syncAll(); });
      });
      LovSizeAdvisor.observer.observe(document.body, { childList: true, subtree: true });
      window.addEventListener('resize', () => LovSizeAdvisor.syncAll());
      document.addEventListener('click', LovSizeAdvisor.guard, true);
      document.addEventListener('change', () => LovSizeAdvisor.syncAll());
      document.addEventListener('submit', LovSizeAdvisor.guard, true);
    }
  }

  customElements.define('lov-size-advisor', LovSizeAdvisor);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lov-size-chart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lov-size-chart')) {
  customElements.define('lov-size-chart', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.trigger = this.querySelector('.lov-size-chart-trigger');
      this.drawer = this.querySelector('.lov-size-chart');
      this.panel = this.querySelector('.lov-size-chart__panel');
      this.addEventListener('click', event => {
        if (event.target.closest('.lov-size-chart-trigger')) this.open();
        if (event.target.closest('[data-chart-close]')) this.close();
      });
      this.addEventListener('keydown', event => {
        if (!this.drawer.classList.contains('is-open')) return;
        if (event.key === 'Escape') { event.preventDefault(); this.close(); }
        if (event.key === 'Tab') {
          const items = [...this.panel.querySelectorAll('button, a[href], [tabindex="0"]')];
          const first = items[0], last = items[items.length - 1];
          if (event.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });
    }
    open() {
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.panel.querySelector('button').focus({preventScroll:true});
    }
    close() {
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      this.trigger.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = this.previousOverflow || '';
      this.trigger.focus({preventScroll:true});
    }
    disconnectedCallback() {
      if (this.drawer?.classList.contains('is-open')) document.documentElement.style.overflow = this.previousOverflow || '';
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
